'use strict';

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _themeVariants = require('@shopify/theme-variants');

var _themeVariants2 = _interopRequireDefault(_themeVariants);

var _themeCurrency = require('@shopify/theme-currency');

var _themeSections = require('@shopify/theme-sections');

var _slickCarousel = require('slick-carousel');

var _slickCarousel2 = _interopRequireDefault(_slickCarousel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var selectors = {
  addToCart: '[data-add-to-cart]',
  addToCartText: '[data-add-to-cart-text]',
  comparePrice: '[data-compare-price]',
  comparePriceText: '[data-compare-text]',
  originalSelectorId: '[data-product-select]',
  priceWrapper: '[data-price-wrapper]',
  productImageWrapper: '[data-product-image-wrapper]',
  productFeaturedImage: '[data-product-featured-image]',
  productJson: '[data-product-json]',
  productPrice: '[data-product-price]',
  productThumbs: '[data-product-single-thumbnail]',
  singleOptionSelector: '[data-single-option-selector]'
}; /**
    * Product Template Script
    * ------------------------------------------------------------------------------
    * A file that contains scripts highly couple code to the Product template.
    *
    * @namespace product
    */

var cssClasses = {
  activeThumbnail: 'active-thumbnail',
  hide: 'hide'
};

var keyboardKeys = {
  ENTER: 13
};

/**
 * Product section constructor. Runs on page load as well as Theme Editor
 * `section:load` events.
 * @param {string} container - selector for the section container DOM element
 */

(0, _themeSections.register)('product', {
  onLoad: function onLoad() {

    this.$container = (0, _jquery2.default)(this.container);
    this.namespace = '.' + this.id;
    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!(0, _jquery2.default)(selectors.productJson, this.$container).html()) {
      return;
    }
    this.productSingleObject = JSON.parse((0, _jquery2.default)(selectors.productJson, this.$container).html());
    var options = {
      $container: this.$container,
      enableHistoryState: this.$container.data('enable-history-state') || true,
      singleOptionSelector: selectors.singleOptionSelector,
      originalSelectorId: selectors.originalSelectorId,
      product: this.productSingleObject
    };

    this.settings = {};
    this.variants = new _themeVariants2.default(options);
    this.$featuredImage = (0, _jquery2.default)(selectors.productFeaturedImage, this.$container);

    this.variants._onSelectChange = function () {
      var variant = this._getVariantFromOptions();
      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      // BEGIN SWATCHES
      var selector = this.originalSelectorId;
      if (variant) {
        var form = (0, _jquery2.default)(selector).closest('form');
        for (var i = 0, length = variant.options.length; i < length; i++) {
          var radioButton = form.find('.swatch[data-option-index="' + i + '"] :radio[value="' + variant.options[i] + '"]');
          if (radioButton.length != 0) {
            if (radioButton) {
              radioButton.get(0).checked = true;
              (0, _jquery2.default)('.p-color-selected .pcs-color-cod').css('background-color', (0, _jquery2.default)(radioButton).attr('data-color'));
              (0, _jquery2.default)('.p-color-selected .pcs-color-cod').css('background-image', (0, _jquery2.default)(radioButton).attr('data-bg'));
              (0, _jquery2.default)('.p-color-selected .pcs-color-name').html((0, _jquery2.default)(radioButton).val());
            }
          }
        }
      }
      // END SWATCHES
      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    };

    this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
    this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));

    if (this.$featuredImage.length > 0) {
      this.$container.on('variantImageChange' + this.namespace, this.updateImages.bind(this));
    }

    this.initImageSwitch();

    this.initSlider(this.variants);
  },
  initImageSwitch: function initImageSwitch() {
    var _this = this;

    var $productThumbs = (0, _jquery2.default)(selectors.productThumbs, this.$container);

    if (!$productThumbs.length) {
      return;
    }

    $productThumbs.on('click', function (evt) {
      evt.preventDefault();
      var imageId = (0, _jquery2.default)(evt.currentTarget).data('thumbnail-id');
      _this.switchImage(imageId);
      _this.setActiveThumbnail(imageId);
    }).on('keyup', this.handleImageFocus.bind(this));
  },
  handleImageFocus: function handleImageFocus(evt) {
    if (evt.keyCode !== keyboardKeys.ENTER) {
      return;
    }

    this.$featuredImage.filter(':visible').focus();
  },
  setActiveThumbnail: function setActiveThumbnail(imageId) {
    var newImageId = imageId;

    // If "imageId" is not defined in the function parameter, find it by the current product image
    if (typeof newImageId === 'undefined') {
      newImageId = (0, _jquery2.default)(selectors.productImageWrapper + ':not(\'.' + cssClasses.hide + '\')').data('image-id');
    }

    var $thumbnail = (0, _jquery2.default)(selectors.productThumbs + '[data-thumbnail-id=\'' + newImageId + '\']');

    (0, _jquery2.default)(selectors.productThumbs).removeClass(cssClasses.activeThumbnail).removeAttr('aria-current');

    $thumbnail.addClass(cssClasses.activeThumbnail);
    $thumbnail.attr('aria-current', true);
  },
  switchImage: function switchImage(imageId) {
    var $newImage = (0, _jquery2.default)(selectors.productImageWrapper + '[data-image-id=\'' + imageId + '\']', this.$container);
    var $otherImages = (0, _jquery2.default)(selectors.productImageWrapper + ':not([data-image-id=\'' + imageId + '\'])', this.$container);
    $newImage.removeClass(cssClasses.hide);
    $otherImages.addClass(cssClasses.hide);
  },


  /**
   * Updates the DOM state of the add to cart button
   *
   * @param {boolean} enabled - Decides whether cart is enabled or disabled
   * @param {string} text - Updates the text notification content of the cart
   */
  updateAddToCartState: function updateAddToCartState(evt) {
    var variant = evt.variant;
    if (variant) {
      (0, _jquery2.default)(selectors.priceWrapper, this.$container).removeClass(cssClasses.hide);
    } else {
      (0, _jquery2.default)(selectors.addToCart, this.$container).prop('disabled', true);
      (0, _jquery2.default)(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
      (0, _jquery2.default)(selectors.priceWrapper, this.$container).addClass(cssClasses.hide);
      return;
    }

    if (variant.available) {
      (0, _jquery2.default)(selectors.addToCart, this.$container).prop('disabled', false);
      (0, _jquery2.default)(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
    } else {
      (0, _jquery2.default)(selectors.addToCart, this.$container).prop('disabled', true);
      (0, _jquery2.default)(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
    }
  },
  updateImages: function updateImages(evt) {
    var variant = evt.variant;
    var imageId = variant.featured_image.id;

    this.switchImage(imageId);
    this.setActiveThumbnail(imageId);
  },


  /**
   * Updates the DOM with specified prices
   *
   * @param {string} productPrice - The current price of the product
   * @param {string} comparePrice - The original price of the product
   */
  updateProductPrices: function updateProductPrices(evt) {
    var variant = evt.variant;
    var $comparePrice = (0, _jquery2.default)(selectors.comparePrice, this.$container);
    var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);

    (0, _jquery2.default)(selectors.productPrice, this.$container).html((0, _themeCurrency.formatMoney)(variant.price, theme.moneyFormat).replace('$', '<sup>$</sup>').replace(',', '').replace('.', '<sup class="money-cents">') + '</sup>');
    if (variant.compare_at_price > variant.price) {
      $comparePrice.html((0, _themeCurrency.formatMoney)(variant.compare_at_price, theme.moneyFormat));
      $compareEls.removeClass(cssClasses.hide);
    } else {
      $comparePrice.html('');
      $compareEls.addClass(cssClasses.hide);
    }
  },
  initSlider: function initSlider(variants) {
    variants._onSelectChange();
    setTimeout(function () {
      if (variants.currentVariant.featured_image.src) {
        (0, _jquery2.default)('.g-slider-nav [data-valueimg="' + variants.currentVariant.featured_image.src + '"]').click();
      }
    }, 1500);
    (0, _jquery2.default)('body').on('change', '.swatch :radio', function () {
      var optionIndex = (0, _jquery2.default)(this).closest('.swatch').attr('data-option-index');
      var optionValue = (0, _jquery2.default)(this).val();
      var optionColorValue = (0, _jquery2.default)(this).attr('data-color');
      var optionBGValue = (0, _jquery2.default)(this).attr('data-bg');
      setTimeout(function () {
        (0, _jquery2.default)('.p-color-selected .pcs-color-name').html(optionValue);
        (0, _jquery2.default)('.p-color-selected .pcs-color-cod').css({ 'background-color': '' + optionColorValue, 'background-image': '' + optionBGValue });
      });
      var select = document.getElementById('SingleOptionSelector-' + optionIndex);
      (0, _jquery2.default)('[data-accordion-content]').hide();
      (0, _jquery2.default)('[data-accordion-toggle]').removeClass('is-open');
      // Change main slide
      select.value = optionValue;
      variants._onSelectChange();

      var variant_img = (0, _jquery2.default)(this).attr('data-variantimg');
      if (variant_img != null) {
        (0, _jquery2.default)('.g-slider-nav [data-valueimg="' + variant_img + '"]').click();
      }
    });
  },


  /**
   * Event callback for Theme Editor `section:unload` event
   */
  onUnload: function onUnload() {
    this.$container.off(this.namespace);
  }
});